import React from 'react';
import ValidInputMultiSelect from '../../../../core/components/validation/ValidInputMultiSelect';
import FormEdit from '../../../../core/components/form/FormEdit';
import ValidInputText from '../../../../core/components/validation/ValidInputText';
import ValidCheckbox from '../../../../core/components/validation/ValidCheckbox';
import Button from '../../../../core/components/Button';
import { ValidOption } from '../../../../core/validSvc';

// provider imports
import useProviderSearchInit from './useProviderSearchInit';
import useProviderSearch from './useProviderSearch';
import useProviderListStore from '../pagehooks/useProviderListStore';
import FormSearch from '../../../../core/components/FormSearch';

const ProviderListSearch = (): JSX.Element => {
    // page action drives query state display in a query/table pattern

    const { action } = useProviderListStore();
    const init = useProviderSearchInit();
    if (init) {
        return <></>;
    }

    const drawerOpen = action == 'QUERY';
    return drawerOpen ? <SearchForm /> : <SearchTitle />;
};

const SearchForm = (): JSX.Element => {
    // search form only deals with the search form, not page state
    const { loading } = useProviderListStore();
    const { state, setProperty, toggleChecked, handleSearch } = useProviderSearch();

    const handleFacilitySelect = (val: (string | number)[]): void => {
        setProperty('CE', val);
    };

    const handleTextChange = (prop: string, val: string): void => {
        setProperty(prop, val);
    };

    const setFieldNPIActive = (val: boolean): void => {
        toggleChecked('NPI', val);
    };

    const setFieldProviderNameActive = (val: boolean): void => {
        toggleChecked('FullName', val);
    };

    return (
        <FormEdit
            formName="providerSearch"
            cssName="provider-search"
            fieldsetId="provider-search-fieldset"
        >
            <div className="fieldset-form">
                <div className="fieldset-inline">
                    <div className="fieldset-section">
                        <ValidInputMultiSelect
                            placeholder="Not Filtered"
                            id="provider-facility"
                            prop={state.CE}
                            onOptionSelect={handleFacilitySelect}
                            insertLeftSpacing
                        />
                    </div>
                    <div className="fieldset-section">
                        <ValidInputText
                            checked={state.NPI.checked}
                            onCheckboxChange={setFieldNPIActive}
                            placeholder="NPI"
                            onChange={handleTextChange}
                            prop={state.NPI}
                            type="Integer"
                        />
                        <ValidCheckbox
                            checked={state.Validated.val}
                            onChange={val => setProperty('Validated', val)}
                            id="provider-validated-checkbox"
                            label="Validated"
                            alignLeft
                        />
                    </div>
                    <div className="fieldset-section">
                        <ValidInputText
                            checked={state.FullName.checked}
                            onCheckboxChange={setFieldProviderNameActive}
                            placeholder="Name"
                            onChange={handleTextChange}
                            prop={state.FullName}
                            alternateLabel="Name"
                        />
                        <ValidCheckbox
                            checked={state.FaxConsent.val}
                            onChange={val => setProperty('FaxConsent', val)}
                            id="provider-fax-consent-checkbox"
                            label="Fax Consent"
                            alignLeft
                        />
                    </div>
                </div>

                <div className="form-field">
                    <Button
                        onClick={handleSearch}
                        cssName="btn-submit"
                        disabled={loading}
                    >
                        SEARCH
                    </Button>
                </div>
            </div>
        </FormEdit>
    );
};

const SearchTitle = (): JSX.Element => {
    const { setAction } = useProviderListStore();
    const { state } = useProviderSearch();

    const criteria = formStateToSearchCriteria(state);

    return (
        <FormSearch
            criteria={criteria}
            onEdit={() => setAction('QUERY')}
        />
    );
};

export default ProviderListSearch;

function formStateToSearchCriteria(state: object): Record<string, ValidOption> {
    // note getting what this does??? shouldn't this be a core function?
    const record = {} as Record<string, ValidOption>;
    Object.keys(state).forEach(key => {
        const prop = state[key];
        if (prop.val !== undefined && prop.val !== '' && prop.val !== false) {
            record[key] = prop;
        }
    });
    return record;
}
